import type React from 'react';

import { SearchIcon } from '@vlabs/icons';
import type { InputProps } from '@vlabs/uikit/components/controls/input/Input';
import { Input } from '@vlabs/uikit/components/controls/input/Input';
import { useTranslation } from 'react-i18next';

import st from './SearchListByNameInput.module.sass';
import { buildTestid } from '../../../shared/lib/utils';

const displayName = 'searchListByNameInput';
const testid = buildTestid(displayName);

function SearchListByNameInput({
  onChange,
  'data-testid': dataTestId = undefined,
  ...props
}: InputProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Input
      className={st.ListNameInput}
      icon={<SearchIcon />}
      placeholder={t('features:search_list_by_name.input.placeholder')}
      {...props}
      {...testid(dataTestId)}
    />
  );
}

SearchListByNameInput.displayName = displayName;

export { SearchListByNameInput };
